import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { EventBlock } from "services/cms/models/eventBlock";

import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";

export interface ResovledEventBlock {
    title: string;
    buttonText?: string;
    buttonHref?: string;
    location: string;
    time: string;
    subTitle: string;
    media: ResolvedImage;
    type: ContentTypeCodenames.EventBlock;
    codename: string;
}

const eventBlockResovler = (data: EventBlock): ResovledEventBlock => {
    return {
        title: data.elements.title.value,
        buttonText: data.elements.ctaLabel.value,
        buttonHref: data.elements.ctaLink.value,
        location: data.elements.location.value,
        time: data.elements.time.value,
        subTitle: data.elements.subTitle.value,
        media: imageResolver(data.elements.image.linkedItems[0]),
        type: ContentTypeCodenames.EventBlock,
        codename: data.system.codename,
    };
};

export default eventBlockResovler;
